const Footer=()=>{
  return(
    <div className="has-text-centered disclaimer">
      <p>&copy;2021 This is an app by <a href="https://twitter.com/io_saeed"> Saeed Wahab</a> </p>
      <p>Disclaimer: This is not official MTN fibre website</p>
    </div>
  )
}

export default Footer;
